// extracted by mini-css-extract-plugin
export default {"spinnerContainer":"SucursalDetalle_spinnerContainer__qYHUg"};